<!--
 * @Description: 作业查询公用组件
 * @Author: yangsibo
 * @Date: 2022-06-13 10:27:22
 * @LastEditors: yangsibo
 * @LastEditTime: 2022-06-24 21:56:58
 * @FilePath: \YunYin_admin\src\views\Cooperative\Disperse\list.vue
-->

<template>
  <el-main>
    <div class="top-wrap">
      <Bread></Bread>
      <div>
        <el-form
          ref="filterForm"
          :inline="true"
          :model="filterForm"
          class="filter-form"
        >
          <el-form-item prop="date">
            <el-date-picker
              v-model="filterForm.date"
              type="daterange"
              range-separator="至"
              start-placeholder="作业开始日期"
              end-placeholder="作业结束日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              style="width: 300px"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item prop="employeeName">
            <el-input
              v-model="filterForm.employeeName"
              placeholder="作业机手"
              style="width: 100px"
            ></el-input>
          </el-form-item>
          <el-form-item prop="categoryId3">
            <el-select
              v-model="filterForm.categoryId3"
              placeholder="农机品目"
              style="width: 120px"
            >
              <el-option label="全部" value="-1"></el-option>
              <el-option
                v-for="item in machineCategories"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="machineryModel">
            <el-input
              v-model="filterForm.machineryModel"
              placeholder="机具型号"
              style="width: 120px"
            ></el-input>
          </el-form-item>
          <el-form-item prop="machineryCode">
            <el-input
              v-model="filterForm.machineryCode"
              placeholder="出厂编号"
              style="width: 150px"
            ></el-input>
          </el-form-item>
          <el-form-item prop="imei">
            <el-input
              v-model="filterForm.imei"
              placeholder="北斗终端编号"
              style="width: 150px"
            ></el-input>
          </el-form-item>
          <el-form-item prop="workTypeCode">
            <el-select
              v-model="filterForm.workTypeCode"
              placeholder="作业类型"
              style="width: 150px"
            >
              <el-option label="全部" value="-1"></el-option>
              <el-option
                v-for="item in cropWork2Data"
                :key="item.id"
                :label="item.workTypeName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleFilterPro('filterForm')"
              >查询</el-button
            >
            <el-button
              type="primary"
              plain
              @click="handleResetFilter('filterForm')"
              ><i class="el-icon-refresh-right"></i>清空</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="main">
      <el-table :data="works" style="width: 100%">
        <el-table-column fixed="left" label="序号" width="60" align="center">
          <template slot-scope="scope">
            {{
              (pagination.currentPage - 1) * pagination.pageSize +
              (scope.$index + 1)
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="workTime"
          label="作业日期"
          min-width="120"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="employeeName"
          label="作业机手"
          min-width="90"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="categoryId3Name"
          label="机具类别"
          min-width="120"
          align="center"
          :resizable="false"
        >
        </el-table-column>
        <el-table-column
          prop="machineryModel"
          label="机具型号"
          min-width="100"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="machineryCode"
          label="出厂编号"
          min-width="150"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="imei"
          label="北斗终端编号"
          min-width="150"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="workTypeName"
          label="作业类型"
          min-width="120"
          align="center"
        >
        </el-table-column>
        <el-table-column label="作业面积" min-width="100" align="center">
          <template slot-scope="scope" v-if="scope.row.workArea"
            >{{ scope.row.workArea }}亩</template
          >
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="110" align="center">
          <template slot-scope="scope">
            <el-button
              type="primary"
              plain
              round
              @click="handleLookDetail(scope.row)"
              >作业查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total,prev, pager, next,jumper"
        :page-size="this.pagination.pageSize"
        :total="pagination.recordTotal"
        :hide-on-single-page="true"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </el-main>
</template>

<script>
export default {
  name: "CooperativeDisperseList",
  data() {
    return {
      filterForm: {
        date: "",
        workStartTimeStr: "",
        workEndTimeStr: "",
        employeeName: "",
        categoryId3: "",
        machineryModel: "",
        machineryCode: "",
        imei: "",
        workTypeCode: "",
      },
      machineCategories: [],
      cropWork2Data: [],
      works: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        recordTotal: 0,
      },
      masterId: "",
    };
  },
  watch: {
    "filterForm.date"(n) {
      console.log(n);
      if (n && n.length == 2) {
        this.filterForm.workStartTimeStr = n[0];
        this.filterForm.workEndTimeStr = n[1];
      } else {
        this.filterForm.workStartTimeStr = "";
        this.filterForm.workEndTimeStr = "";
      }
    },
  },
  mounted() {
    this.getDisperseWorkList();
    this.getMachineCategorys();
    this.getCropWork2();
  },
  created() {
    this.masterId = this.$route.query.$businessAccountId;
  },
  methods: {
    /**
     * @descripttion: 获取散活作业列表
     * @Author: juanjuanhui
     * @Date: 2022-04-21 10:57:08
     */
    getDisperseWorkList() {
      this.getAllFilters();
      let { currentPage, pageSize } = this.pagination;
      let params = { currentPage, pageSize, masterId: this.masterId };
      Object.assign(params, params, this.allFilters);
      this.$http.cooperative.getDisperseWorkList(params).then((res) => {
        let { recordTotal, content: works } = res.data;
        this.pagination.recordTotal = recordTotal;
        this.works = works;
      });
    },
    /**
     * @descripttion: 获取机具分类
     * @Author: juanjuanhui
     * @Date: 2021-11-25 21:24:54
     */
    getMachineCategorys() {
      this.$http.common.getMachineCategorys().then((res) => {
        this.machineCategories = res.data;
      });
    },
    /**
     * @descripttion: 获取作业类型二级
     * @Author: juanjuanhui
     * @Date: 2022-04-21 15:54:32
     */
    getCropWork2() {
      this.$http.common.getCropWork2().then((res) => {
        this.cropWork2Data = res.data;
      });
    },
    /**
     * @descripttion: 获取查询参数
     * @Author: juanjuanhui
     * @Date: 2021-06-23 22:06:58
     */
    getAllFilters() {
      let { date, ...data } = this.filterForm;
      this.allFilters = { ...data };
      if (this.allFilters.categoryId3 == -1) {
        delete this.allFilters.categoryId3;
      }
      if (this.allFilters.workTypeCode == -1) {
        delete this.allFilters.workTypeCode;
      }
    },
    /**
     * @descripttion:
     * @Author: juanjuanhui
     * @Date: 2022-04-22 09:12:04
     * @param {*} params 当前数据项
     */
    handleLookDetail(params) {
      let { id, employeeId, machineIdentity, imei, workTime, iotType } = params;
      this.$router.push({
        path: "/cooperative/disperse/detail",
        query: { id, employeeId, machineIdentity, imei, workTime, iotType },
      });
    },
    /**
     * @descripttion: 切换分页
     * @Author: juanjuanhui
     * @Date: 2021-06-23 22:14:09
     * @param {Number} val 当前页码
     */
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.getDisperseWorkList();
    },
    /**
     * @descripttion: 查询数据
     * @Author: juanjuanhui
     * @Date: 2022-04-21 16:53:32
     */
    handleFilterPro() {
      this.pagination.currentPage = 1;
      this.getDisperseWorkList();
    },
    /**
     * @Description: 重置条件
     * @Author: zhanghongquan
     * @Date: 2022-03-30 15:35:56
     * @param {*}
     */
    handleResetFilter(filterForm) {
      this.$refs[filterForm].resetFields();
      this.pagination.currentPage = 1;
      this.filterForm.date = "";
      this.filterForm.workStartTimeStr = "";
      this.filterForm.workEndTimeStr = "";
      this.getDisperseWorkList();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/common.scss";
</style>
